import angular from 'angular';
import $ from 'jquery';
import template from './template.html';
import './style.scss';

export const DATE_PICKER_DEFAULT_OPTIONS = {
    todayBtn: 'linked',
    clearBtn: true,
    format: 'dd/mm/yyyy',
    autoclose: true,
    orientation: 'bottom right',
    maxViewMode: 0,
    todayHighlight: true
};

export class TFTDatepicker {
    $datepicker = null;
    canEdit = true;

    /* @ngInject */
    constructor($element, $scope, $timeout) {
        this.$scope = $scope;
        this.$element = $element;
        this.$timeout = $timeout;
    }

    getFormattedDate(date) {
        if (!date) {
            return null;
        }

        return new Date(date).toLocaleDateString('en-GB');
    }

    isEqualDate(firstDate, secondDate) {
        const formattedFirstDate = this.getFormattedDate(firstDate);
        const formattedSecondDate = this.getFormattedDate(secondDate);

        return formattedFirstDate === formattedSecondDate;
    }

    $onInit() {
        const { $element, options, value, $timeout } = this;
        const resultOptions = {
            ...DATE_PICKER_DEFAULT_OPTIONS,
            ...(options || {}),
        };

        this.$datepicker = $($element[0].children[0]);
        this.$datepicker.datepicker(resultOptions);
        this.setValue(value);

        this.$datepicker.on('changeDate', ({ date }) => {
            if (this.isEqualDate(this.value, date)) {
                return;
            }

            this.onChange({ date });
            $timeout(() => this.setValue(this.value));
        });
    }

    setValue(value) {
        const { $datepicker } = this;
        const copyValue = angular.copy(value);

        if ($datepicker) {
            $datepicker.datepicker('setDate', copyValue ? new Date(copyValue) : null);
        }
    }

    $onChanges() {
        this.setValue(this.value);
    }
}

export const TFTDatepickerConfiguration = {
    template,
    bindings: {
        value: '<',
        options: '<',
        canEdit: '<',
        placeholderKey: '@',
        tooltipLabelKey: '@',
        onChange: '&',
    },
    controller: TFTDatepicker,
    controllerAs: 'tftDatepickerCtrl',
};

angular
    .module('TALENYA-FE')
    .component('tftDatepicker', TFTDatepickerConfiguration);
